import showAntiFlickerScript from "./showAntiFlickerScript";

export default showAntiFlickerScript;
